import React, { useEffect } from 'react'
import { FormikProps, withFormik, Form } from 'formik'
import { useTranslation } from 'react-i18next'
import { useWindowSize } from '../../../helpers/hooks/hookWindowsSize'

interface DeleteProps {
  onSubmit?: (values: DeleteValues) => void
  children?: React.ReactNode
  data: {
    _id: string
  }
  handleClose: (close: boolean) => void
}

interface DeleteValues {
  _id: string
}

const InnerForm: React.FunctionComponent<
  DeleteProps & FormikProps<DeleteValues>
> = ({ values, data, handleClose }) => {
  const { t } = useTranslation()
  const sizeWidth = useWindowSize().width
  const { _id } = data

  useEffect(() => {
    values._id = _id
  }, [_id])

  const handleCancelClick = () => {
    handleClose(false)
  }

  return (
    <>
      <div className='container-form'>
        <Form>
          <div className='d-flex flex-column div-body-padding p-5'>
            <span className='padding-bottom-1'>{`${t(
              'DELETE_PARAGRAPH_1'
            )}`}</span>
            <span className='padding-bottom-1'>{`${t(
              'DELETE_PARAGRAPH_2'
            )}`}</span>
            <span className='padding-bottom-1'>
              <strong>{`${t('DELETE_PARAGRAPH_3')}`}</strong>
            </span>

            <div className='container-buttton-center'>
              <button
                className={`button-third ${
                  sizeWidth > 768 ? 'margin-right-2' : 'margin-bottom-1'
                }`}
                type='button'
                onClick={handleCancelClick}
              >
                {`${t('CANCEL')}`}
              </button>
              <button className='button-danger width-200' type='submit'>
                {`${t('YES_DELETE')}`}
              </button>
            </div>
          </div>
        </Form>
      </div>
    </>
  )
}

const DeleteLinkForm = withFormik<DeleteProps, DeleteValues>({
  mapPropsToValues: (props: any) => {
    const initialValues: DeleteValues = {
      _id: props.data._id,
    }
    return { ...initialValues, ...props }
  },

  handleSubmit(values: DeleteValues, { props }: any) {
    if (props.onSubmit) {
      props.onSubmit(values)
    }
  },
})(InnerForm)
export default DeleteLinkForm
